import { IPermissionModel } from './';

export const RBDMPermissions: IPermissionModel[] = [
	{
		name: 'Dashboard',
		route: '/',
		components: [
			'total-out-off-view',
			'total-out-off-view-site',
			'total-site-leads-from-kae',
			'total-competition-site-visited',
			'total-site-visited',
			'rbdm-specific-widget',
			'regional-overview',
			'performance-metrics',
			'rbdm-tabs',
			'attendance-check',
		],
	},
	{ name: 'AllEndUser', route: '/end-users/all', components: [] },
	{ name: 'AllEndUser', route: '/rbdm/end-users/all', components: ['add-new-rbdm-btn'] },
	{ name: 'AllRigidUser', route: '/rbdm/end-users/all-rigid', components: ['add-new-rbdm-btn'] },
	{ name: 'Supervisor', route: '/rbdm/supervisor', components: [] },
	{ name: 'SupervisorDetails', route: '/supervisor/edit-supervisor', components: ['supervisor-view'] },
	{ name: 'Scheme', route: '/scheme', components: [] },
	{ name: 'Profile', route: '/profile', components: [] },
	{ name: 'CompetitionConversion', route: '/competition-conversion', components: [] },
	{ name: 'TypeOfContractor', route: '/competition-conversion/type-of-contractor', components: [] },
	{ name: 'GradeOfCompetition', route: '/competition-conversion/grade-of-competition', components: [] },
	{ name: 'ProductsRecommended', route: '/competition-conversion/products-recommended', components: [] },
	{ name: 'Meetings', route: '/rbdm/meetings', components: [] },
	{ name: 'TodaysMeetings', route: '/rbdm/meetings/todays-meetings', components: [] },
	{ name: 'AllMeetings', route: '/rbdm/meetings/all-meetings', components: [] },
	{ name: 'TodayMeetings', route: '/rbdm/today-meetings', components: [] },
	{ name: 'AddNewMeeting', route: '/rbdm/add-new-meeting', components: ['imr-dropdown', 'bde-meeting-fields'] },
	{ name: 'Contractor', route: '/rbdm/contractor', components: ['product-recommendation', 'add-new-rbdm'] },
	{ name: 'StaticDetails', route: '/rbdm/contractor/static-details', components: [] },
	{ name: 'EditMeeting', route: '/edit-meeting', components: ['imr-dropdown', 'bde-meeting-fields'] },
	{ name: 'FieldMarketingContent', route: '/field-marketing-content', components: [] },
	{ name: 'StructureQuestionnaires', route: '/structured-questionnaires', components: [] },
	{ name: 'Jharokha', route: '/jharokha', components: [] },
	{ name: 'HelpAndSupport', route: '/help-and-support', components: [] },
	{ name: 'MeetingDetails', route: '/meeting-details', components: [] },
	{ name: 'ProductPerformance', route: '/product-performance', components: [] },
	{ name: 'TodayMeetings', route: '/today-meetings', components: [] },
	{ name: 'MeetingsConducted', route: '/meetings-conducted', components: ['meetings-conducted'] },
	{ name: 'EditBasicDetails', route: '/edit-member-details/basic-details', components: ['rbdm-edit-details'] },
	{ name: 'PointsStatement', route: '/contractor/points-statement', components: [] },
	{ name: 'BankingDetails', route: '/contractor/banking-details', components: ['rbdm-banking-details'] },
	{ name: 'SupervisorSummary', route: '/contractor/supervisor-summary', components: [] },
	{ name: 'RedemptionHistory', route: '/contractor/redemption-history', components: [] },
	{ name: 'DealerDetails', route: '/contractor/dealer-details', components: [] },
	{ name: 'ArchitectDetails', route: '/contractor/architect-details', components: [] },
	{ name: 'BankingHistory', route: '/contractor/banking-history', components: [] },
	{
		name: 'EditKycDetails',
		route: '/edit-member-details/kyc-details',
		components: ['bde-code-field', 'rbdm-next-btn'],
	},
	{
		name: 'EditMoreDetails',
		route: '/edit-member-details/more-details',
		components: [
			'bde-enroll-fnb-start-field',
			'901',
			'902',
			'903',
			'904',
			'kae-carpenter-field',
			'rbdm-btn',
			'bde-code-field',
		],
	},
	{ name: 'UserSufficiencySummary', route: '/user-sufficiency-summary', components: [] },
	{ name: 'SiteSummary', route: '/rbdm/site-summary', components: ['add-new-site-btn-rbdm'] },
	{ name: 'SiteLeadOverview', route: '/rbdm/site-lead-overview', components: ['add-new-site-btn-rbdm'] },
	{ name: 'SiteDetails', route: '/rbdm/site-lead-overview/site-details', components: ['add-new-site-btn-rbdm'] },
	{ name: 'VisitDetails', route: '/rbdm/site-lead-overview/visit-details', components: ['add-new-site-btn-rbdm'] },
	{ name: 'MDPMeetings', route: '/rbdm/meetings/mdp', components: ['add-new-meeting-btn-rbdm'] },
	{ name: 'AddNewMdpMeeting', route: '/rbdm/add-new-mdp-meeting', components: ['add-new-meeting-btn-rbdm'] },
];
